<template>
  <div class="person">
    <div class="icon" v-html="PersonSvg" />
    <div class="info">
      <div class="name">
        {{ props.person.username || useAddressFormat(props.person.public_key) }}
      </div>
      <div class="role">
        {{ props.person.access_level }}
      </div>
    </div>
    <div v-if="!isCurrentUser" class="options">
      <DeployerUiDropdownNav>
        <DeployerUiDropdownNavButton
          :icon-svg="AdminSvg"
          label="Make admin"
          @click.prevent="changeRole"
        />
        <hr />
        <DeployerUiDropdownNavButton
          :icon-svg="RemoveSvg"
          label="Remove user"
          @click.prevent="removeUser"
        />
      </DeployerUiDropdownNav>
    </div>
  </div>
</template>

<script setup>
import PersonSvg from '~/layers/base/assets/icons/person.svg?raw'
import AdminSvg from '~/layers/base/assets/icons/preferred.svg?raw'
import RemoveSvg from '~/layers/base/assets/icons/delete.svg?raw'
import { ACCESS_LEVELS } from '../../../stores/account.js'

const props = defineProps({
  person: Object,
  isCurrentUser: {
    default: () => false
  }
})

const accountStore = useAccountStore()
const newWalletStore = useNewWalletStore()

const changeRole = async () => {
  await accountStore.updateAccess(
    props.person.public_key,
    ACCESS_LEVELS.READ_WRITE
  )
}

const removeUser = async () => {
  await accountStore.removeWalletFromAccount(props.person.public_key)
}
</script>

<style lang="scss" scoped>
.person {
  border-radius: 10px;
  border: 1px solid var(--field-stroke, rgba(0, 0, 0, 0.2));
  background: var(--field-bg, #fff);
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.icon {
  width: 35px;
  height: 35px;
  opacity: 0.7;

  :deep(svg) {
    width: 35px;
    height: 35px;
  }

  :deep(path) {
    stroke: var(--Text, #000);
  }
}

.info {
  flex: 1 1 0;
  font-size: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.options {
  width: 30px;
  height: 30px;

  &:has(.nav-opened) {
    position: relative;
    z-index: 10;
  }
}

.name {
  font-weight: 500;
  opacity: 0.7;
}

.role {
  opacity: 0.5;
}
</style>
